import NotFound from "@/assets/images/not-found.png";
import Image from "next/image";

export default function Empty({ title, desc }) {
  return (
    <div className='flex flex-col items-center justify-center p-6 mt-4 border border-dashed rounded-md'>
      <Image
        src={NotFound.src}
        width={100}
        height={100}
        className='h-24'
        alt='Item Not Found'
      />
      <p className='mt-4 font-medium'>{title}</p>
      <p className='mt-0.5 text-xs opacity-40'>{desc}</p>
    </div>
  );
}
